import { getServerTime } from "@/lib/appwrite";
import { useState, useEffect, useRef } from "react";

export function useServerTime(refreshInterval = 60000) {
  const [serverTime, setServerTime] = useState<Date | null>(null);
  const timestampRef = useRef<number>(0);
  const localStartRef = useRef<number>(0);

  useEffect(() => {
    async function fetchTime() {
      try {
        const execution = await getServerTime();

        const responseBody = execution.responseBody;
        if (responseBody) {
          const data = JSON.parse(responseBody);
          setServerTime(new Date(data.timestamp));
          timestampRef.current = data.timestamp;
          localStartRef.current = Date.now();
        }
      } catch (error) {
        console.error("Error obteniendo la hora del servidor", error);
      }
    }

    fetchTime();

    const interval = setInterval(fetchTime, refreshInterval);
    return () => clearInterval(interval);
  }, [refreshInterval]);

  function getCurrentServerTime() {
    if (!timestampRef.current) return null;
    const elapsed = Date.now() - localStartRef.current;
    return new Date(timestampRef.current + elapsed);
  }

  function getCurrentEcuadorTimeString() {
    const now = getCurrentServerTime();
    if (!now) return null;
    return now.toLocaleTimeString("es-EC", {
      timeZone: "America/Guayaquil",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }

  return {
    serverTime,
    getCurrentServerTime,
    getCurrentEcuadorTimeString,
  };
}
